import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ConfirmDelete } from "MODULES/shared/components";

export class Delete extends Component {
  static propTypes = {
    primary: PropTypes.bool.isRequired,
    destroy: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired
  };

  state = {
    open: false
  };

  open = e => {
    e.stopPropagation();
    this.setState({ open: true });
  };

  close = () => this.setState({ open: false });

  destroy = () => {
    const { id, destroy } = this.props;
    destroy(id);
  };

  render() {
    const { primary } = this.props;
    return (
      <td className="text-right">
        {!primary && (
          <button className="btn-link" onClick={this.open}>
            <span className="text-danger">
              <i className="fa fa-fw fa-close" />
            </span>
          </button>
        )}
        <ConfirmDelete
          onConfirm={this.destroy}
          close={this.close}
          open={this.state.open}
        >
          <strong>Heads up!</strong> Are you sure you want to delete this?
        </ConfirmDelete>
      </td>
    );
  }
}

export default connect(undefined, (dispatch, ownProps) => ({
  destroy: id => dispatch(ownProps.deleteAction(id))
}))(Delete);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Delete/Delete.jsx